import * as yup from 'yup';

export const UsersPhoneNumbersSchema = yup.object({
  fromDate: yup.string().required('From Date is required'),
  toDate: yup.string().required('From Date is required'),
  verified: yup.boolean().required(),
  viewAll: yup.boolean().required(),
});
